module.exports = __webpack_public_path__ + "assets/img/6a80-mh.svg";